import React from "react";

interface AddWhiteIconProps {
    size?: number | string;
    color?: string;
    className?: string;
    onClick?: () => void;
}

const AddWhiteIcon: React.FC<AddWhiteIconProps> = ({
    size = 20,
    color = 'white',
    className,
    onClick,
}) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        onClick={onClick}
    >
        <path d="M6 12H18" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 18V6" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default AddWhiteIcon;
